import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Formik, ErrorMessage, Form, Field } from 'formik'
//import RichTextEditor from 'react-rte'
import DatePicker from 'react-datepicker'
import { registerLocale } from 'react-datepicker'
import { submitFuehrerschein, removeFuehrerschein, fetchOneFuehrerscheinByEmail, fetchOneUserByAuth } from '../../actions'
import de from 'date-fns/locale/de'
import "react-datepicker/dist/react-datepicker.css";

var _ = require('lodash');

registerLocale('de', de);

const inputStyle = {
  marginBottom: '10px'
}

class FuehrerscheinEdit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      rtvalue: '',
    }
    this.cancelLink = this.cancelLink.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.nfcPresent = this.nfcPresent.bind(this);
    //this.dataThere = this.dataThere.bind(this);
  }

  componentDidMount() {
    this.props.fetchOneUserByAuth();
    const thisEmail = this.props.match.params.email;
    const id = this.props.match.params.fn;
    console.log("in FuehrerscheinEdit, email:", thisEmail);
    console.log("in FuehrerscheinEdit, id:", id);
    this.props.fetchOneFuehrerscheinByEmail(thisEmail, id);
  }

  cancelLink() {
    var cancelPath = '/';
    if (this.props.auth) {
      cancelPath = '/fahrer';
    }
    return cancelPath;
  }

  isAdmin() {
    if (!this.props.auth) {
      return false;
    }
    if (this.props.auth.roles.indexOf('admin')>-1) {
      return true;
    } else {
      return false;
    }
  }

  handleDateChange(date) {
    this.setState({
      startDate:date
    });
  }

  handleFnLoeschen(uuid) {
    this.props.removeFuehrerschein({ uuid }, this.props.history);
  }

  nfcPresent(nfcUid) {
    const re = {nfcPresent: false, text: "Hinweis: Das NFC-Label zu diesem Führerschein ist noch nicht eingelesen." };
    if (nfcUid) {
      re.text = "nfcUid: " + nfcUid;
      re.nfcPresent = true;
    }
    return re;
  }

  render() {
    var initValues = {
      licenseDate:this.state.startDate,
      email:this.props.match.params.email
    }
    initValues = this.props.fuehrerschein[0];
    console.log("initialValues 1:", initValues);
    if (initValues === undefined) {
      initValues = {};
    }
    // vorab das licenseValidDate festlegen (erscheint nicht in der Oberfläche)
    initValues.licenseValidDate = new Date();

    var anzahlFuehrerscheine = 0;

    if (this.props.fuehrerschein.hasOwnProperty('result')) {
      initValues = _.clone(this.props.fuehrerschein.result.fahrer.fuehrerschein[0]); // fuehrerschein ist eingefaltet...
      anzahlFuehrerscheine = this.props.fuehrerschein.result.fahrer.fuehrerschein.length;
      console.log("Anzahl Führerscheine:", anzahlFuehrerscheine);
      initValues.email = this.props.match.params.email;
    }

    console.log("initValues in FuehrerscheinEdit:", initValues);

    if (anzahlFuehrerscheine < 1) {
      return (
        <span>Wir kennen keinen Führerschein mit diesen Daten.</span>
      )
    }

    return (
      <div>

        <h4 style={{fontStyle:'italic'}}>Führerschein bearbeiten</h4>
        {/*}<p>({initValues.uuid})</p>
      <p>({initValues.licenseValidDate})</p>*/}

        <Formik
          enableReinitialize={true}
          initialValues={initValues}
          validate={values => {
            let errors = {};
            if (!values.email) {
              errors.email = 'Die Mailadresse ist erforderlich.';
            } else if (
              !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
            ) {
              errors.email = 'Keine gültige Email-Adresse';
            }

            //console.log("licenseValid in validate:", values.licenseValid);
            //console.log("initValues.licenseValid:", initValues.licenseValid);
            //console.log("values.licenseValid:", values.licenseValid);

            // Kommt mir etwas "hacky" vor, das im Validator abzuhandeln... ToDo: Besser machen
            const licenseValidSetPositive = ((initValues.licenseValid === false) && (values.licenseValid === true));
            console.log("licenseValid zu 'true' geändert:", licenseValidSetPositive);
            values.licenseValidSetPositive = licenseValidSetPositive;

            if (!values.licenseId) {
              errors.licenseId = 'Die Führerscheinnummer ist erforderlich.';
            }
            return errors;
          }}

          onSubmit={(values, { setSubmitting }) => {

              if (values.licenseValid) {
                values.licenseValidDate = new Date();
              }
              values.newFn=false;
              setSubmitting(true);
              this.props.submitFuehrerschein( values, this.props.history );
              setSubmitting(false);
          }}
        >

          {({ isSubmitting, props, setFieldValue, initValues, values, setSubmitting }) => (

            <Form
              onKeyPress={e => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
            }}>
              <label htmlFor="vorname">Vorname</label>
              <Field name="vorname" style={inputStyle} />
              <ErrorMessage name="vorname" component="div" />

              <label htmlFor="nachname">Nachname</label>
              <Field name="nachname" style={inputStyle} />
              <ErrorMessage name="nachname" component="div" />

              <label htmlFor="licenseDate">Ausstellungsdatum</label>
              <DatePicker
                selected={values.licenseDate}
                locale='de'
                dateFormat="d. MMMM yyyy"
                onChange={(e) => setFieldValue('licenseDate', e)}
                showYearDropdown
                dateFormatCalendar="MMMM"
                scrollableYearDropdown
                yearDropdownItemNumber={50}
                name="licenseDate" />
              <ErrorMessage name="licenseDate" component="div" />

              <label htmlFor="licenseId">Nummer des Führerscheins</label>
              <Field name="licenseId" style={inputStyle} />
              <ErrorMessage name="licenseId" component="div" />

              <label htmlFor="email">Email</label>
              <Field name="email" style={inputStyle} />
              <ErrorMessage name="email" component="div" />

              <label htmlFor="licenseValid">Führerschein geprüft</label>
              {/*
              <Field name="licenseValid" type="checkbox" value={values.licenseValid} style={{display: 'block'}} />
              */}
              <input
                name="licenseValid"
                id="licenseValid"
                type="checkbox"
                value={values.licenseValid}
                checked={values.licenseValid}
                style={{display:'block'}}
                onChange={e => setFieldValue('licenseValid', !values.licenseValid)}
              />
              <ErrorMessage name="licenseValid" component="div" />

              <label htmlFor="nextLicenseCheck" style={{display:'block', marginTop:'0.5em'}}>Nächste Prüfung ab</label>
              <DatePicker
                selected={values.nextLicenseCheck}
                locale='de'
                dateFormat="d. MMMM yyyy"
                onChange={(e) => setFieldValue('nextLicenseCheck', e)}
                showYearDropdown
                dateFormatCalendar="MMMM"
                scrollableYearDropdown
                yearDropdownItemNumber={50}

                name="nextLicenseCheck" />
              <ErrorMessage name="nextLicenseCheck" component="div" />

              <Field type="hidden" name="newFn" value="false" />

              <div
                style={{
                  marginTop: '0.5em',
                  color: this.nfcPresent(values.nfcUid).nfcPresent ? 'black':'#900'
                }}
                name="nfcUid">{this.nfcPresent(values.nfcUid).text}</div>

              <div>
              <button
                type="button"
                className="float-right btn btn-default"
                onClick={() => this.handleFnLoeschen(values.uuid)}>
                  Löschen
              </button>

              <Link to={this.cancelLink()} style={{marginRight: '10px'}} type="cancel">
                <button className="btn btn-secondary" >
                <span style={{color: 'white'}}>Abbrechen</span>
                </button>
              </Link>

              <button className="btn btn-default" type="submit" disabled={isSubmitting}>
                Absenden
              </button>
              </div>

            </Form>
          )}
        </Formik>
        <div style={{height: "80px"}}></div>
      </div>
    )}
}

const mapDispatchToProps = {
  fetchOneFuehrerscheinByEmail,
  fetchOneUserByAuth,
  submitFuehrerschein,
  removeFuehrerschein
}

function mapStateToProps({ auth, singleUser, fuehrerschein }) {
	return { auth, singleUser, fuehrerschein }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(FuehrerscheinEdit);



// WEBPACK FOOTER //
// ./src/components/fahrer/FuehrerscheinEdit.js